var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _g, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCitiart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 211,
    viewBox: "0 0 390 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23873_123)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23873_123",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 393,
    height: 211
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M393 0H0V211H393V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23873_123)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.284 192.734V136.064H82.7448V110.222H74.5076V101.024H72.4011C71.4212 90.0544 63.7865 80.9814 53.5214 77.8017V73.2128H49.3818C49.3818 68.9591 49.3818 63.4902 49.3818 63.4902H41.4851C41.4851 63.4902 41.4851 68.9644 41.4851 73.2128H37.3507C37.3507 73.2128 37.3507 76.7749 37.3507 77.8017C27.0856 80.9814 19.4509 90.0544 18.471 101.024H16.3645V110.222H8.17441V135.98H-67.3497V191.906L101.279 192.734H101.284Z",
    fill: "#272761"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-41.6475 173.592H42.4912V158.678L47.0762 152.937L51.6612 158.678V163.12C51.6612 163.12 65.1961 171.764 86.5962 171.764C98.3862 171.764 101.284 170.109 101.284 170.109V200.057H-41.6475V173.597V173.592Z",
    fill: "#001369"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.217 171.507H143.555V128.143L145.541 121.443L147.606 127.368L151.405 115.288L155.057 127.337L157.226 121.443L159.217 128.143V171.507Z",
    fill: "url(#paint0_linear_23873_123)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M239.264 171.507H223.601V128.143L225.587 121.443L227.647 127.368L231.451 115.288L235.098 127.337L237.267 121.443L239.264 128.143V171.507Z",
    fill: "url(#paint1_linear_23873_123)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M314.437 168.055V95.8219L317.282 88.2L320.127 95.8219V107.048L324.351 100.285H330.529L334.752 107.048V95.8219L337.597 88.2L340.443 95.8219V159.579L314.437 168.055Z",
    fill: "url(#paint2_linear_23873_123)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M262.828 163.414V95.8219L265.673 88.2L268.519 95.8219V107.048L272.742 100.285H278.92L283.149 107.048V95.8219L285.989 88.2L288.834 95.8219V126.105V171.486L262.828 163.414Z",
    fill: "url(#paint3_linear_23873_123)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M370.52 26.7476V18.9842",
    stroke: "#0AA075",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M314.437 169.758V95.8219L317.282 88.2L320.127 95.8219V107.048L324.351 100.285H330.529L334.752 107.048V95.8219L337.597 88.2L340.443 95.8219V178.16",
    stroke: "#0AA075",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M262.828 163.414V95.8219L265.673 88.2L268.519 95.8219V107.048L272.742 100.285H278.92L283.149 107.048V95.8219L285.989 88.2L288.834 95.8219V126.105V170.994",
    stroke: "#0AA075",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M314.437 116.98H288.834",
    stroke: "#0AA075",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M357.688 161.036V88.2262L355.062 86.0208V64.826H358.924V56.5964L364.023 49.5821V39.0213L370.489 26.7109L376.955 39.0213V49.5821L382.054 56.5964V64.826H385.915V86.0208L383.29 88.2262V118.656H396.694V132.711H423.371",
    stroke: "#0AA075",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M340.443 121.527L347.281 130.684H357.31",
    stroke: "#0AA075",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M140.123 200.052V172.173H162.618V200.052",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M159.458 171.753V126.97L157.399 118.808L155.366 126.886L151.384 112.48L147.375 126.886L145.337 118.808L143.283 126.97V172.042",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M145.331 118.819V115.498",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M151.389 112.491V109.17",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M157.399 118.819V115.498",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M239.52 171.753V126.97L237.461 118.808L235.428 126.886L231.446 112.48L227.437 126.886L225.399 118.808L223.345 126.97V172.042",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M225.393 118.819V115.498",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M231.451 112.491V109.17",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M237.461 118.819V115.498",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M140.123 173.592H52.1852",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M220.237 172.613H162.796",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M222.962 135.257H160.192",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M222.962 139.485H160.192",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M162.629 177.788C162.629 177.788 181.194 172.613 192.947 172.613",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M87.356 171.764C111.727 171.764 127.961 161.35 143.324 142.015",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3109 163.12C61.5019 169.433 75.3302 171.748 87.3508 171.78",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3968 200.052V158.746H51.766V200.052",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6664 158.684L47.0238 152.869L42.4912 158.684",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M242.68 200.052V172.173H220.185V200.052",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M242.68 173.592H330.618",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M220.174 177.788C220.174 177.788 201.609 172.613 189.856 172.613",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M295.447 171.764C271.118 171.764 254.9 161.387 239.562 142.12",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M330.487 163.12C321.296 169.433 307.467 171.748 295.447 171.78",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M340.406 200.052V158.746H331.037V200.052",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M340.307 158.684L335.779 152.869L331.137 158.684",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M340.443 173.592H352.61",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7314 173.592H-41.6475",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M-41.6475 192.734H6.46092L16.9724 200.052H361.544L369.603 188.789H416.999",
    stroke: "#0124D0",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M101.284 200.052V136.064H82.7448V110.222H74.5076V101.024H72.4011C71.4212 90.0544 63.7865 80.9814 53.5214 77.8017V73.2128H49.3818C49.3818 68.9591 49.3818 63.4902 49.3818 63.4902H41.4851C41.4851 63.4902 41.4851 68.9644 41.4851 73.2128H37.3507C37.3507 73.2128 37.3507 76.7749 37.3507 77.8017C27.0856 80.9814 19.4509 90.0544 18.471 101.024H16.3645V110.222H8.1744V135.98H-67.3497",
    stroke: "#DB3C8E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_23873_123",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 344,
    y: 135,
    width: 111,
    height: 66
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M454.974 188.789H369.603L361.544 200.052H344.263V135.257H454.974V188.789Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_23873_123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.576 175.263L406.399 170.994L416.999 188.789L403.124 203.954L384.197 195.159L386.576 175.263Z",
    stroke: "#007BFE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.806 233.798C425.216 233.798 446.626 212.394 446.626 185.992C446.626 159.589 425.216 138.185 398.806 138.185C372.396 138.185 350.986 159.589 350.986 185.992C350.986 212.394 372.396 233.798 398.806 233.798Z",
    stroke: "#007BFE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.739 145.608L381.566 148.552L375.928 164.247L359.852 171.533L356.383 164.991",
    stroke: "#007BFE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.008 196.159L357.473 187.254L369.603 199.784L371.081 217.862L363.127 217.983",
    stroke: "#007BFE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.603 199.784L384.197 195.159",
    stroke: "#007BFE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.576 175.263L375.928 164.247",
    stroke: "#007BFE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.852 171.533L357.473 187.254",
    stroke: "#007BFE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.566 148.552L397.758 144.922",
    stroke: "#007BFE",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M101.284 172.193C102.436 172.193 103.369 171.26 103.369 170.109C103.369 168.957 102.436 168.024 101.284 168.024C100.132 168.024 99.1984 168.957 99.1984 170.109C99.1984 171.26 100.132 172.193 101.284 172.193Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M101.284 175.677C102.436 175.677 103.369 174.744 103.369 173.592C103.369 172.441 102.436 171.507 101.284 171.507C100.132 171.507 99.1984 172.441 99.1984 173.592C99.1984 174.744 100.132 175.677 101.284 175.677Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M101.284 202.136C102.436 202.136 103.369 201.203 103.369 200.052C103.369 198.9 102.436 197.967 101.284 197.967C100.132 197.967 99.1984 198.9 99.1984 200.052C99.1984 201.203 100.132 202.136 101.284 202.136Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M140.123 202.136C141.275 202.136 142.208 201.203 142.208 200.052C142.208 198.9 141.275 197.967 140.123 197.967C138.971 197.967 138.037 198.9 138.037 200.052C138.037 201.203 138.971 202.136 140.123 202.136Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M162.618 202.136C163.77 202.136 164.704 201.203 164.704 200.052C164.704 198.9 163.77 197.967 162.618 197.967C161.466 197.967 160.533 198.9 160.533 200.052C160.533 201.203 161.466 202.136 162.618 202.136Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M220.237 202.136C221.389 202.136 222.323 201.203 222.323 200.052C222.323 198.9 221.389 197.967 220.237 197.967C219.085 197.967 218.152 198.9 218.152 200.052C218.152 201.203 219.085 202.136 220.237 202.136Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M242.68 202.136C243.832 202.136 244.766 201.203 244.766 200.052C244.766 198.9 243.832 197.967 242.68 197.967C241.528 197.967 240.595 198.9 240.595 200.052C240.595 201.203 241.528 202.136 242.68 202.136Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M352.61 202.136C353.762 202.136 354.696 201.203 354.696 200.052C354.696 198.9 353.762 197.967 352.61 197.967C351.458 197.967 350.525 198.9 350.525 200.052C350.525 201.203 351.458 202.136 352.61 202.136Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M364.804 197.244C365.955 197.244 366.889 196.31 366.889 195.159C366.889 194.007 365.955 193.074 364.804 193.074C363.652 193.074 362.718 194.007 362.718 195.159C362.718 196.31 363.652 197.244 364.804 197.244Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M384.49 190.874C385.642 190.874 386.576 189.94 386.576 188.789C386.576 187.637 385.642 186.704 384.49 186.704C383.338 186.704 382.405 187.637 382.405 188.789C382.405 189.94 383.338 190.874 384.49 190.874Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M352.61 175.677C353.762 175.677 354.696 174.744 354.696 173.592C354.696 172.441 353.762 171.507 352.61 171.507C351.458 171.507 350.525 172.441 350.525 173.592C350.525 174.744 351.458 175.677 352.61 175.677Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M314.437 171.843C315.588 171.843 316.522 170.909 316.522 169.758C316.522 168.606 315.588 167.673 314.437 167.673C313.285 167.673 312.351 168.606 312.351 169.758C312.351 170.909 313.285 171.843 314.437 171.843Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M288.834 173.079C289.986 173.079 290.92 172.145 290.92 170.994C290.92 169.842 289.986 168.909 288.834 168.909C287.682 168.909 286.749 169.842 286.749 170.994C286.749 172.145 287.682 173.079 288.834 173.079Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M262.828 165.205C263.98 165.205 264.913 164.272 264.913 163.12C264.913 161.969 263.98 161.036 262.828 161.036C261.676 161.036 260.742 161.969 260.742 163.12C260.742 164.272 261.676 165.205 262.828 165.205Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M357.473 163.817C358.625 163.817 359.558 162.884 359.558 161.732C359.558 160.581 358.625 159.647 357.473 159.647C356.321 159.647 355.387 160.581 355.387 161.732C355.387 162.884 356.321 163.817 357.473 163.817Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M51.766 202.136C52.9178 202.136 53.8515 201.203 53.8515 200.052C53.8515 198.9 52.9178 197.967 51.766 197.967C50.6142 197.967 49.6804 198.9 49.6804 200.052C49.6804 201.203 50.6142 202.136 51.766 202.136Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4912 202.136C43.643 202.136 44.5767 201.203 44.5767 200.052C44.5767 198.9 43.643 197.967 42.4912 197.967C41.3394 197.967 40.4056 198.9 40.4056 200.052C40.4056 201.203 41.3394 202.136 42.4912 202.136Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23873_123",
    x1: 151.389,
    y1: 171.507,
    x2: 151.389,
    y2: 115.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#001369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#001D78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0045B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#0062DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#0074F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007BFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23873_123",
    x1: 231.43,
    y1: 0.0000352422,
    x2: 231.43,
    y2: 0.0000352422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#001369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#001D78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0045B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#0062DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#0074F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007BFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_23873_123",
    x1: 327.437,
    y1: 168.055,
    x2: 327.437,
    y2: 88.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#001369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#001A69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#04536E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#077D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#099674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AA075"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_23873_123",
    x1: 275.834,
    y1: 171.486,
    x2: 275.834,
    y2: -0.000021625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#001369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#001A69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#04536E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#077D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#099674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AA075"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23873_123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393,
    height: 211,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitiart);
export default __webpack_public_path__ + "static/media/citiart.0749719259cf8c2906c16eca3665902c.svg";
export { ForwardRef as ReactComponent };